// Date 2020-10-27 09:31:32

import sithMesQualityKpiPassRate from "@/store/sithMes/quality/SithMesQualityKpiPassRateStore.js";
import sithMesQualityInspectTask from "@/store/sithMes/quality/SithMesQualityInspectTaskStore";
import sithMesQualityInspectTemplate from "@/store/sithMes/quality/SithMesQualityInspectTemplateStore";
import sithMesQualityInspectTemplateData from "@/store/sithMes/quality/SithMesQualityInspectTemplateDataStore";
import sithMesQualityInspectType from "@/store/sithMes/quality/SithMesQualityInspectTypeStore";
import sithMesNcrProcessTask from "@/store/sithMes/quality/SithMesNcrProcessTaskStore.js";
import sithMesQualityToolManage from "@/store/sithMes/quality/SithMesQualityToolManageStore.js";
import sithMesQualityToolBorrowRecord from "@/store/sithMes/quality/SithMesQualityToolBorrowRecordStore.js";
import sithMesQualityToolCheckResult from "@/store/sithMes/quality/SithMesQualityToolCheckResultStore.js";
import sithMesQualityToolScrap from "@/store/sithMes/quality/SithMesQualityToolScrapStore.js";
import sithMesNcrTaskNccItem from "@/store/sithMes/quality/SithMesNcrTaskNccItemStore.js";
import sithMesNcrTaskNcc from "@/store/sithMes/quality/SithMesNcrTaskNccStore.js";
import sithMesQualityInspectCommonTemplate from "@/store/sithMes/quality/SithMesQualityInspectCommonTemplateStore.js";
import sithMesQualityDocument from "@/store/sithMes/quality/SithMesQualityDocumentStore.js";
import emStocktakingTaskQuality from "@/store/em/archive/EmStocktakingTaskStore";
import emStocktakingTaskDetailQuality from "@/store/em/archive/EmStocktakingTaskDetailStore";

const genericEntities = [
    'sithMesQualityKpiPassRate',
    'sithMesQualityInspectTask',
    'sithMesQualityInspectTemplate',
    'sithMesQualityInspectTemplateData',
    'sithMesQualityInspectType',
    'sithMesNcrProcessTask',
    'sithMesQualityToolManage',
    'sithMesQualityToolBorrowRecord',
    'sithMesQualityToolCheckResult',
    'sithMesQualityToolScrap',
    'sithMesNcrTaskNccItem',
    'sithMesNcrTaskNcc',
    'sithMesQualityInspectCommonTemplate',
    'sithMesQualityDocument',
    'emStocktakingTaskQuality',
    'emStocktakingTaskDetailQuality'
]

const entities = {
    sithMesQualityKpiPassRate,
    sithMesQualityInspectTask,
    sithMesQualityInspectTemplate,
    sithMesQualityInspectTemplateData,
    sithMesQualityInspectType,
    sithMesNcrProcessTask,
    sithMesQualityToolManage,
    sithMesQualityToolBorrowRecord,
    sithMesQualityToolCheckResult,
    sithMesQualityToolScrap,
    sithMesNcrTaskNccItem,
    sithMesNcrTaskNcc,
    sithMesQualityInspectCommonTemplate,
    sithMesQualityDocument,
    emStocktakingTaskQuality,
    emStocktakingTaskDetailQuality
}

export {genericEntities}

export default entities
